<div class="settings-page">
  <div class="content-center" [class.overlay-open]="showInlineEditor || showFeeReportOverlay">
    
    <div class="top-controls">
      <div class="pill-group">
        <button 
          class="pill-btn" 
          [class.active]="activeTab === 'accounts'" 
          (click)="setTab('accounts')">
          Payment Accounts
        </button>
        <button 
          class="pill-btn" 
          [class.active]="activeTab === 'recipients'" 
          (click)="setTab('recipients')">
          Fee Recipients
        </button>
      </div>

      <div class="right-actions">
        <a *ngIf="activeTab === 'accounts'" class="text-link" (click)="openNewAccountEditor()">
          New Payment Account
        </a>
        
        <ng-container *ngIf="activeTab === 'recipients' && canGenerateFeeRecipients">
            <a class="text-link" (click)="initiateFeeGeneration()" 
               [class.disabled-link]="waitingOnReport">
              {{ waitingOnReport ? 'Searching Workflows...' : 'Generate Fee Recipients' }}
            </a>
        </ng-container>
      </div>
    </div>

    <div class="new-item-inline" *ngIf="showInlineEditor">
      <div class="new-item-header">
        <div class="title">
          <span *ngIf="editorType === 'account' && !isEditingAccount">New Payment Account</span>
          <span *ngIf="editorType === 'account' && isEditingAccount">Edit Payment Account</span>
          <span *ngIf="editorType === 'recipient'">
            {{ editingFeeRecipientId ? 'Edit' : 'New' }} Fee Recipient
          </span>
        </div>
        <button class="close-btn" (click)="closeInlineEditor()">✕</button>
      </div>

      <div *ngIf="editorType === 'account'">
        
        <div class="account-status-bar" *ngIf="isEditingAccount">
           <div class="status-label">
             {{ selectedAccount.inTestMode ? 'Using Test Settings' : 'Using Live Settings' }}
           </div>
           <div class="status-actions">
             <button class="btn-toggle btn-mode" 
               [class.btn-danger]="selectedAccount.inTestMode"
               [class.btn-success]="!selectedAccount.inTestMode"
               [class.disabled-btn]="!isModeSwitchAllowed" 
               [disabled]="!isModeSwitchAllowed"
               (click)="requestToggleTestMode()">
               {{ selectedAccount.inTestMode ? 'GO LIVE' : 'SWITCH TO TEST' }}
             </button>
             
             <button class="btn-toggle btn-enable"
               [class.btn-success]="selectedAccount.isEnabled" 
               [class.btn-danger]="!selectedAccount.isEnabled"
               (click)="requestToggleEnabled()">
               {{ selectedAccount.isEnabled ? 'DISABLE' : 'ENABLE' }}
             </button>
           </div>
           
           <div *ngIf="!isModeSwitchAllowed" class="text-danger mt-2" style="font-size: 12px; margin-top: 8px;">
              <span *ngIf="selectedAccount.inTestMode">
                The payment processor is in Test Mode and therefore the account cannot be made live.
              </span>
              <span *ngIf="!selectedAccount.inTestMode">
                Account is Live. Switching back to Test Mode is disabled.
              </span>
           </div>
        </div>

        <form [formGroup]="accountForm" (ngSubmit)="saveAccount()">
          <div class="form-grid-row">
            <div class="form-col">
              <input class="input" formControlName="name" placeholder="Account Name" />
              <div class="error-msg" *ngIf="accountForm.get('name')?.invalid && accountForm.get('name')?.touched">Required</div>
            </div>
            
            <div class="form-col relative-col">
              <div class="custom-dropdown">
                <div class="dropdown-header input" (click)="toggleDropdown()">
                  {{ selectedProcessorName }}
                </div>
                <ul class="dropdown-list" *ngIf="isDropdownOpen">
                  <li *ngFor="let proc of availableProcessors" (click)="selectProcessor(proc)">
                    {{ proc.name }}
                  </li>
                </ul>
              </div>
              <div class="error-msg" *ngIf="accountForm.get('processor')?.invalid && accountForm.get('processor')?.touched">Required</div>
            </div>
          </div>

          <div class="config-section" *ngIf="accountForm.get('processor')?.value">
            <div class="config-header">
               <div class="pill-group">
                  <button type="button" class="pill-btn" 
                          [class.active]="activeConfigTab === 'live'" 
                          (click)="activeConfigTab = 'live'">
                    LIVE SETTINGS
                  </button>
                  <button type="button" class="pill-btn" 
                          [class.active]="activeConfigTab === 'test'" 
                          (click)="activeConfigTab = 'test'">
                    TEST SETTINGS
                  </button>
                </div>
            </div>

            <div [hidden]="activeConfigTab !== 'live'" class="dynamic-form-container">
               <div formGroupName="prodForm">
                  <ng-template #prodProviderConfigView></ng-template>
               </div>
            </div>

            <div [hidden]="activeConfigTab !== 'test'" class="dynamic-form-container">
               <div formGroupName="testForm">
                  <ng-template #testProviderConfigView></ng-template>
               </div>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn-cancel" (click)="closeInlineEditor()">CANCEL</button>
            <button type="submit" class="btn btn-save" 
              [disabled]="isSaving || accountForm.get('name')?.invalid || accountForm.get('processor')?.invalid">
              SAVE
            </button>
          </div>
        </form>
      </div>

      <form *ngIf="editorType === 'recipient'" [formGroup]="recipientForm" (ngSubmit)="saveRecipient()">
        <div class="form-single-row">
          <div class="form-col">
             <input class="input" formControlName="name" placeholder="Fee Recipient Name" />
             <div class="error-msg" *ngIf="recipientForm.get('name')?.invalid && recipientForm.get('name')?.touched">Required</div>
          </div>
        </div>
        <div class="form-actions">
          <button type="button" class="btn btn-cancel" (click)="closeInlineEditor()">CANCEL</button>
          <button type="submit" class="btn btn-save" [disabled]="isSaving || recipientForm.invalid">SAVE</button>
        </div>
      </form>
    </div>

    <div class="new-item-inline overlay-section" *ngIf="showFeeReportOverlay">
        <div class="new-item-header">
          <div class="title">Generate Fee Recipient</div>
          <button class="close-btn" (click)="closeFeeReportOverlay()">✕</button>
        </div>
        
        <div class="fee-report-body">
          <p class="mb-3 font-weight-bold">
            Fee recipients were found on Fee Data Entities in the following Workflow Builders:
          </p>
          <div class="workflow-list-container">
            <div *ngFor="let w of feeRecipientGenerationImpactReport?.impactedWorkflows" class="workflow-item">
              <span class="workflow-name">{{ w.workflowName }}</span>
              <span class="workflow-status" *ngIf="w.lastPendingChangesMade">
                 (Has Pending Changes: {{ w.lastPendingChangesMade }})
              </span>
            </div>
          </div>
          <div class="warning-text mt-4">
            <p>Generating Fee Recipients from these workflows will automatically associate fee recipients being used in Fee Data Entities with this list.  The Workflow Builder updates will not be published, instead the workflow will show Changes Available if there were not already unpublished changes made to the workflow.</p>
            <p><strong>Before proceeding, it is recommended that the above list of workflows be copy/pasted and saved for reference for when these workflow changes will be published.</strong></p>
            <p>Do you want to continue and generate fee recipients from those found in these workflows?</p>
          </div>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-cancel" (click)="closeFeeReportOverlay()">CANCEL</button>
          <button type="button" class="btn btn-primary" (click)="confirmFeeGeneration()">YES</button>
        </div>
    </div>
    <section *ngIf="activeTab === 'accounts'" class="content-section">
      <div class="card">
        
        <div class="table-responsive">
          <div class="grid-row header account-grid">
            <div class="col-head">Name</div>
            <div class="col-head">Actions</div>
          </div>
          
          <div class="grid-body">
              <div class="standalone-loader" *ngIf="isLoadingAccounts">
                <div class="spinner-border custom-blue-spinner" role="status"></div>
                <span class="loading-text">Loading payment accounts...</span>
              </div>

              <ng-container *ngIf="!isLoadingAccounts">
                <div class="grid-row account-grid" *ngFor="let acc of paymentAccounts">
                    <div class="col-text" style="cursor: default;">
                        {{ acc.name }}
                    </div>
                    <div class="col-action">
                        <a class="action-link action-edit" (click)="editAccount(acc)">Edit</a>
                        <span class="separator">|</span>
                        <a class="action-link action-delete" (click)="requestRemoveAccount(acc.id)">Remove</a>
                    </div>
                </div>
              
                <div class="empty-state" *ngIf="paymentAccounts && paymentAccounts.length === 0">
                    No Payment Accounts found.
                </div>
              </ng-container>
          </div>
        </div>

      </div>
    </section>

    <section *ngIf="activeTab === 'recipients'" class="content-section">
      <div class="card">
        
        <div class="table-responsive">
          <div class="grid-row header recipient-grid">
            <div class="col-head">Name</div>
            <div class="col-head">Edit</div>
            <div class="col-head">Delete</div>
            <div class="col-head text-right">
               <button class="btn btn-primary" (click)="openNewRecipientEditor()">ADD FEE RECIPIENT</button>
            </div>
          </div>

          <div class="grid-body">
            <div class="grid-row recipient-grid" *ngFor="let r of feeRecipients">
              <div class="col-text">{{ r.value }}</div>
              <div class="col-action">
                <a class="action-link action-edit" (click)="editRecipient(r)">Edit</a>
              </div>
              <div class="col-action">
                <a class="action-link action-delete" (click)="requestDeleteRecipient(r.id)">Delete</a>
              </div>
              <div class="col-empty"></div>
            </div>

            <div class="empty-state" *ngIf="feeRecipients && feeRecipients.length === 0">
              No Fee Recipients to display. Click Add Fee Recipient to add.
            </div>
          </div>
        </div>

      </div>
    </section>

  </div>

  <wm-common-confirmation-modal
    [data]="confirmData"
    (onYesClick)="onConfirmYes()"
    (onNoClick)="onConfirmNo()"
    [isApplicantMobileview]="true"
  ></wm-common-confirmation-modal>
</div>